export class Request{
    public empCd: string
    public workingYm: string
    public detailNo: string
    public requestStatus: string
    public requestKbn: string
    public workingKbn: string
    public vacationKbn: string
    public workingDate: string
    public exchangeDate: string
    public beforeHolidayKbn:string
    public requestRemarks: string
    public decisionRemarks: string
    public decisionDate: string
    public decisionEmpCd: string
    public lastRegistrationDate: string
    public lastRegistrationEmpCd: string
    public lastRegistrationEmpNm: string
    public approvalDate1st: Date
    public approvalEmpCd1st: string
    public approvalDate2nd: Date
    public approvalEmpCd2nd: string
    public approvalDate3rd: Date
    public approvalEmpCd3rd: string
    public confirmDate1st: Date
    public confirmEmpCd1st: string
    public confirmDate2nd: Date
    public confirmEmpCd2nd: string
    public confirmDate3rd: Date
    public confirmEmpCd3rd: string
    public creationDate: string
    public creationUser: string
}
